import React from 'react'
import './Banner.css';
import Button from '../Button/Button';
import '../App.css';

function Banner() {
  return (
    <>
    <div className='banner container'>
        <div className='banner container-inner'>
        <h1 className='header'>Certified Nutritionist + Dietition</h1>
            <p className='intro'>Are you planning on a better look in the mirror? Or simply want to improve health
                and physical..... The first step you achieved by looking into what to do.
                <br/> Let me take care of the other steps for you! I am dedicated and determined to guide,
                motivate, and help fulfill your goal. 
                <br/> Help find out the reason of certain symptoms + Dietary menu + lifestyle changes to get you feelin
                your <strong>BEST!!!</strong>
            </p>
              {/* </div>
            <div className='btns-contain'> */}
                <Button
                
                className="btns"
                buttonStyle= "btn--primary"
                buttonSize= "btn-large"
                >Book Your Appointment</Button>
            </div>
    </div>
    </>
  )
}

export default Banner